import { Button, Form, Input, Flex } from 'antd';
import classesAuth from '../../common/styles/FormStyles.module.scss';
import profileClasses from '../../pages/Profile/style.module.scss';
import getInputRules from '../../utils/getInputRules';

export default function TwoFactorAuthForm({ loading, showCancel, submitDisabled, onBackClick, onFormSubmit, t }) {
    return (
        <Form onFinish={onFormSubmit} layout="vertical" requiredMark={false}>
            <Form.Item
                label={t('settings:2FA.form.label')}
                name="code"
                hasFeedback
                validateDebounce={1000}
                rules={getInputRules(
                    t,
                    null,
                    t('settings:2FA.form.required'),
                    t('settings:2FA.form.minmax'),
                    true,
                    false
                )}
            >
                <Input.OTP
                    size="large"
                    placeholder={t('settings:2FA.form.placeholder')}
                    disabled={submitDisabled}
                    autoComplete="off"
                    className={classesAuth['input-login']}
                />
            </Form.Item>
            <Flex
                justify={showCancel ? 'space-between' : 'start'}
                align="center"
                style={{ marginTop: 30, gap: '20px' }}
            >
                {showCancel && (
                    <Button
                        htmlType="button"
                        onClick={onBackClick}
                        className={profileClasses.backButton}
                        type="default"
                        size="large"
                    >
                        {t('settings:2FA.form.cancel')}
                    </Button>
                )}
                <Button
                    htmlType="submit"
                    loading={loading}
                    disabled={submitDisabled}
                    className={profileClasses.submitForm}
                    type="primary"
                    size="large"
                >
                    {t('settings:2FA.form.submit')}
                </Button>
            </Flex>
        </Form>
    );
}
